import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ExpandableTextContainer from 'components/essentials/ExpandableTextContainer';
const ProductListingPageDescriptionUI = t0 => {
  const $ = _c(7);
  const {
    label: t1,
    children
  } = t0;
  const label = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== label) {
    t2 = <h2 className="relative text-lg font-bold text-gray pb-6 mb-2 text-center after:content-[''] after:block after:w-28 after:h-px after:bg-gray-light7 after:absolute after:bottom-0 after:left-1/2 after:-ml-14">{label}</h2>;
    $[0] = label;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = children || "";
  let t4;
  if ($[2] !== t3) {
    t4 = <div className="text-sm leading-6 tracking-[0.2px] text-gray mt-6 text-center [&_a]:text-brand [&_li]:list-none"><ExpandableTextContainer content={t3} /></div>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <div className="mx-auto my-24 max-w-[736px]">{t2}{t4}</div>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
ProductListingPageDescriptionUI.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string
};
export default ProductListingPageDescriptionUI;